;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './experiences-block.scss')]).then(() => {
    $('.widget.experiences-block').each(function (i, el) {
      $(el).data('widget', new ExperiencesBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function ExperiencesBlock(el, Swiper) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ExperiencesBlock init', self)
    }
    self.el.css('opacity', 1)

    // Handle the case where the swiper is inside a tab that is not currently visible
    self.parentTabPanel = self.el.parent('.js-panel')
    if (self.parentTabPanel.length && self.parentTabPanel.attr('aria-hidden') === 'true') {
      window.dbs.globalEvents.subscribe('tab_revealed', onTabRevealed)
    } else {
      // If the parent is not a tab, just initialize the swipers
      self.initSwipers()
    }
  }

  function onTabRevealed(payload) {
    if (payload.id === self.parentTabPanel?.attr('id')) {
      self.initSwipers()
      // Once initialized, unsubscribe from the event
      window.dbs.globalEvents.unsubscribe('tab_revealed', onTabRevealed)
    }
  }

  self.initSwipers = function () {
    self.initParentSwiper()

    // Find all nested swiper elements and initialize them
    const nestedSwipers = self.el.find('.swiper .swiper')
    console.log('nestedSwipers', nestedSwipers)
    nestedSwipers.each(function (i, swiperEl) {
      self.initNestedSwiper($(swiperEl))
    })
  }

  self.initParentSwiper = function () {
    // NOTE: Swiper can have nested sliders, so we need to find the first swiper instance
    const swiperEl = self.el.find('.swiper').first()
    // Find all slides in the swiper
    const slides = swiperEl.find('> .swiper-wrapper > .swiper-slide')
    swiperEl.attr('data-slides-count', slides.length)
    // Only setup navigation if there are more than 4 slides
    let navigation = {}
    if (slides.length > 4) {
      // Buttons are not within the swiperEl, but within the parent element
      const nextEl = self.el.find('.swiper-button-next.experiences-block-swiper-button')
      const prevEl = self.el.find('.swiper-button-prev.experiences-block-swiper-button')

      navigation = {
        nextEl,
        prevEl,
      }

      // Show the navigation buttons
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
    }

    self.swiper = new Swiper(swiperEl, {
      loop: false,
      autoHeight: false,
      watchOverflow: true,
      slidesPerView: 'auto',
      navigation,
      pagination: {
        el: swiperEl.find('> .swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }

  self.initNestedSwiper = function (swiperEl) {
    // Find all slides in the swiper
    const slides = swiperEl.find('.swiper-slide')
    if (slides.length < 2) {
      return
    }

    // Show the navigation buttons
    const nextEl = swiperEl.find('.swiper-button-next')
    const prevEl = swiperEl.find('.swiper-button-prev')
    nextEl.removeClass('!hidden')
    prevEl.removeClass('!hidden')

    // TODO this should not be assigned to self.swiper, but rather an array of nested swipers that we can loop and destroy later
    self.swiper = new Swiper(swiperEl, {
      loop: false,
      autoHeight: false,
      watchOverflow: true,
      allowTouchMove: false, // disable touch swiping for nested swipers
      slidesPerView: 'auto',
      navigation: {
        nextEl: swiperEl.find('.swiper-button-next'),
        prevEl: swiperEl.find('.swiper-button-prev'),
      },
      pagination: {
        el: swiperEl.find('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }
}
